// extracted by mini-css-extract-plugin
var _1 = "main__Dvs1x";
export { _1 as "main" }
export default { "main": _1 }
